import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Tabs } from '@studiometa/ui';
import ZoomedGallery from './ZoomedGallery/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import TopBar from './TopBar.js';
import RichTextPanel from '../Shop/RichTextPanel.js';
import Slider from './Slider/index.js';
import SlideComplementaire from './Slider/Swiper.js';
import Baseline from './Baseline.js';
import Hero from './Hero.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      Tabs,
      Slider,
      SlideComplementaire,
      ZoomedGallery,
      Baseline,
      TopBar,
      Action,
      RichTextPanel,
      Hero,
      StaticMap: (app) => importWhenVisible(() => import('./StaticMap.js'), 'StaticMap', app),
      Shoemakers: (app) =>
        importWhenVisible(() => import('./Shoemakers/index.js'), 'Shoemakers', app),
      Instagram: (app) => importWhenVisible(() => import('./Instagram/index.js'), 'Instagram', app),
      ProductLastViewed,
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
    },
  };
}
